import { Link } from 'react-router-dom'
import { Logo } from '../components/brand/Logo'
import { AppShell } from '../components/layout/AppShell'
import { Button } from '../components/ui/button'
import { useAuth } from '../context/AuthContext'

export function NotFoundPage() {
  const { dashboardPath } = useAuth()

  return (
    <AppShell>
      <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
        <Logo size="md" />
        <p className="mt-8 font-display text-7xl font-bold text-green-600">404</p>
        <h1 className="mt-4 font-display text-3xl font-bold text-ink-900">Page not found</h1>
        <p className="mt-3 max-w-md text-sm text-ink-600">
          The page you requested does not exist or you do not have access to it.
        </p>
        <Button asChild className="mt-8">
          <Link to={dashboardPath}>Back to Dashboard</Link>
        </Button>
      </div>
    </AppShell>
  )
}
